import { render } from "./MFITTBookingSelectCarNumber.vue?vue&type=template&id=34131bd6&scoped=true"
import script from "./MFITTBookingSelectCarNumber.vue?vue&type=script&lang=js"
export * from "./MFITTBookingSelectCarNumber.vue?vue&type=script&lang=js"

import "./MFITTBookingSelectCarNumber.vue?vue&type=style&index=0&id=34131bd6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34131bd6"

export default script